import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnColorPickerTemplateOptions } from './color-picker-template-options.interface';

export interface ISnColorPickerFormFieldConfig extends FormlyFieldConfig {
  type: 'color-picker';
  templateOptions?: ISnColorPickerTemplateOptions;
}
